import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/assemblies-parts/parts");
